import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PopUpModal from "../../modals/PopUpModal";
import { useNavigate } from "react-router-dom";
import { AcmeCoOperationErrorIcon, AddUserIcon, BackArrowIcon, CommunicationsIcon, GrowthIcon, HealthIcon, HomeIcon, LowRiskIcon, MentoringIcon, NewNotificationIcon, OverViewIcon, PhoneIcon, PlusIcon, plusIcon, trophyIcon, YellowWarningIcon } from "../../assets/icons";
import { HomeModernIcon } from "@heroicons/react/20/solid";
import CommonModal from "../../modals/CommonModal";
import CommunicationsTab from "../../components/CommunicationsTab";
import UsageHealthTab from "../../components/UsageHealthTab";
import TabsHeader from "../../components/TabsHeader";
import OpportunitiesTab from "../../components/OpportunitiesTab";
import { Select } from "antd";
const priorityOptions = [
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Low", label: "Low" },
];
const CommunicationType = [
    { value: "Call", label: "Call" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
    { value: "Support", label: "Support" },
];
const participantsOptions = [
    { value: "John smith", label: "John smith" },
    { value: "Sarah Johnson", label: "Sarah Johnson" },
    { value: "Emily Jones", label: "Emily Jones" },
];
const assigneeOptions = [
    { value: "Sarah Johnson", label: "Sarah Johnson" },
    { value: "Product Team", label: "Product Team" },
    { value: "Support Team", label: "Support Team" },
    { value: "Negotiation", label: "Negotiation" },
];
// import OpportunitiesTab from "../../components/OpportunitiesTab";
// Form validation schemas
const taskSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    description: Yup.string().required('Description is required'),
    dueDate: Yup.date().required('Due date is required'),
    priority: Yup.string().required('Priority is required'),
});

const communicationSchema = Yup.object().shape({
    type: Yup.string().required('Type is required'),
    summary: Yup.string().required('Summary is required'),
    details: Yup.string().required('Details are required'),
    date: Yup.date().required('Date is required'),
});

const opportunitySchema = Yup.object().shape({
    name: Yup.string().required('Opportunity name is required'),
    value: Yup.number().required('Value is required').positive('Value must be positive'),
    stage: Yup.string().required('Stage is required'),
    closeDate: Yup.date().required('Close date is required'),
});

export default function AccountPage() {
    const navigate = useNavigate();
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [showCommunicationModal, setShowCommunicationModal] = useState(false);
    const [showOpportunityModal, setShowOpportunityModal] = useState(false);
    const [showImpersonateModal, setShowImpersonateModal] = useState(false);
    // const tabs = ["Overview", "Communications", "Usage & Health", "Opportunities"];
    const tabs = [
        { name: "Overview", icon: OverViewIcon },
        { name: "Communications", icon: CommunicationsIcon },
        { name: "Usage & Health", icon: HealthIcon },
        { name: "Opportunities", icon: MentoringIcon },
    ]

  const [activeTab, setActiveTab] = useState(tabs[0].name);

    return (
        <>
            <div className="rounded-md border-[1px] border-solid border-[#F3EFEF] space-y-8 sm:p-6 p-3">
                <div className="">
                    <div className="mb-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-[16px] font-normal flex gap-1 hover:opacity-80 transition-opacity"
                        >
                            {BackArrowIcon} Back
                        </button>
                    </div>
                    <div className="heading flex gap-2 justify-between items-end mb-[24px]">
                        <div className="heading-title space-y-1">
                            <h1 className="text-h2 !font-medium mb-0">Acme co-operation </h1>
                            <p className="text-span text-dark mb-0">
                                Comprehensive Customer Relationship management
                            </p>
                        </div>
                    </div>

          {/* Top card */}
          <div className="bg-[#EDF7FF] rounded-xl sm:p-6 p-3">
            <div className="flex flex-col xl:flex-row md:items-start gap-4 md:justify-between">
              <div className="flex items-center gap-2">
                <span className="min-[40px]">{AcmeCoOperationErrorIcon}</span>
                <div className="">
                  <span className="text-[16px] font-semibold mb-2 block">
                    Enterprise Customer relationship management
                  </span>
                  <p className="text-[16px] text-gray-500 text-sm mb-0">
                    Comprehensive tenant relationship management with account
                    health tracking, opportunity pipeline and customer success
                    metrics
                  </p>
                </div>
              </div>
              <div className="mt-4 md:mt-0 flex gap-2 flex-col sm:flex-row">
                <button className="whitespace-nowrap btn-light-blue sm:w-[150px] w-full !gap-2 ">
                  {NewNotificationIcon}Task
                </button>
                <button className="whitespace-nowrap btn-light-gray sm:w-[150px] w-full !gap-2 !bg-[#DBE9FF] !text-[#4285F4]">
                  {LowRiskIcon}Low Risk
                </button>
                <button className="whitespace-nowrap btn-light-gray sm:w-[150px] w-full !gap-2 !bg-[#DBE9FF] !text-[#4285F4]">
                  {" "}
                  {GrowthIcon}Growth
                </button>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="mt-6">
            <TabsHeader
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
          {/* Tab content */}
          <div className="tab-content mt-6">
            {activeTab === "Overview" && (
              <>
                {/* Metrics */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="chart-card">
                    <p className="mb-2 text-sm font-medium">Account health</p>
                    <p className="text-blue-600 text-xl font-bold mb-0">85%</p>
                  </div>
                  <div className="chart-card">
                    <p className="mb-2 text-sm font-medium">
                      Monthly recurring revenue
                    </p>
                    <p className="text-blue-600 text-xl font-bold mb-0">
                      $4,500
                    </p>
                  </div>
                  <div className="chart-card">
                    <p className="mb-2 text-sm font-medium">NPS score</p>
                    <p className="text-blue-600 text-xl font-bold mb-0">8/10</p>
                  </div>
                  <div className="chart-card">
                    <p className="mb-2 text-sm font-medium">Days to renewal</p>
                    <p className="text-blue-600 text-xl font-bold mb-0">85%</p>
                  </div>
                </div>

                {/* Content */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                  {/* Account summary */}
                  <div className="chart-card w-full">
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-span text-black !font-semibold mb-0 flex items-center justify-between mb-4 w-full">
                        Account summary
                        <div className="flex gap-2">
                          <span className="color-label bg-[#E9FFDE] text-[#52C41A] ">
                            {LowRiskIcon}
                            Low Risk
                          </span>
                          <span className="color-label bg-[#DBE9FF]  text-[#4285F4]">
                            {GrowthIcon}
                            Growth
                          </span>
                        </div>
                      </h2>
                    </div>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Account Owner :
                        </span>{" "}
                        Sarah Johnson
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Lifestyle value :
                        </span>{" "}
                        $54,000
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Users :
                        </span>{" "}
                        54,000
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Contract value :
                        </span>{" "}
                        $54,000
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          CSAT :
                        </span>{" "}
                        ⭐⭐⭐⭐⭐
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Renewal date :
                        </span>{" "}
                        12 July 1025
                      </li>
                    </ul>
                  </div>

                                    {/* Quick actions */}
                                    <div className="chart-card w-full">
                                        <h2 className="text-span text-black !font-semibold mb-0 mb-4">Quick actions</h2>
                                        <div className="grid md:grid-cols-2 gap-4 h-[calc(100%-60px)]">
                                            <button
                                                className="bg-[#FFEAD4] py-3 rounded-lg font-medium hover:bg-orange-200 flex flex-col items-center justify-center gap-2 text-[16px] font-semibold text-[#000]"
                                                onClick={() => setShowTaskModal(true)}
                                            >
                                                {PlusIcon} Create Task
                                            </button>
                                            <button
                                                onClick={() => setShowCommunicationModal(true)}
                                                className="bg-[#D6E3FF] py-3 rounded-lg font-medium hover:bg-blue-200 flex flex-col items-center justify-center gap-2 text-[16px] font-semibold text-[#000]">
                                                {PhoneIcon} Log Communication
                                            </button>
                                            <button
                                                onClick={() => setShowOpportunityModal(true)}
                                                className="bg-[#D0FFDD] py-3 rounded-lg font-medium hover:bg-green-200 flex flex-col items-center justify-center gap-2 text-[16px] font-semibold text-[#000]">
                                                {trophyIcon} Add opportunity
                                            </button>
                                            <button
                                                onClick={() => setShowImpersonateModal(true)}
                                                className="bg-[#D8FFFC] py-3 rounded-lg font-medium hover:bg-gray-200 flex flex-col items-center justify-center gap-2 text-[16px] font-semibold text-[#000]">
                                                {AddUserIcon} Impersonate Tenant
                                            </button>
                                        </div>
                                    </div>
                                </div>

                {/* Bottom */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                  <div className="chart-card w-full">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">
                      Activity and engagement
                    </h2>
                    <ul className="text-sm text-gray-600 space-y-2">
                      <li className="text-span !font-semibold text-[#52C41A]">
                        <span className="text-span !font-medium text-[#000]">
                          Activity score :
                        </span>{" "}
                        87%
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Daily Active Users :
                        </span>{" "}
                        98%
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Weekly Active Users :
                        </span>{" "}
                        98%
                      </li>
                      <li className="text-span !font-semibold text-[#000]">
                        <span className="text-span !font-medium text-[#4F4B45]">
                          Monthly Active Users :
                        </span>{" "}
                        98%
                      </li>
                    </ul>
                  </div>

                  <div className="chart-card w-full">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">
                      Support mechanics
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                      <div className="chart-card !shadow-none">
                        <p className="mb-2 text-sm ">Open Tickets</p>
                        <p className="text-blue-600 text-xl font-bold mb-0">
                          2
                        </p>
                      </div>
                      <div className="chart-card !shadow-none">
                        <p className="mb-2 text-sm">Resolved</p>
                        <p className="text-blue-600 text-xl font-bold mb-0">
                          47
                        </p>
                      </div>
                      <div className="chart-card !shadow-none">
                        <p className="mb-2 text-sm">Average response</p>
                        <p className="text-blue-600 text-xl font-bold mb-0">
                          4.2hrs
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {activeTab === "Communications" && (
              <div className="w-full">
                <CommunicationsTab />
              </div>
            )}

            {activeTab === "Usage & Health" && (
              <div className="w-full">
                <UsageHealthTab />
              </div>
            )}

                        {activeTab === "Opportunities" && (
                            <div className="w-full">
                                <OpportunitiesTab />
                            </div>
                        )}
                    </div>
                </div>

            </div>
            {/* <CommonModal
                visible={showTaskModal}
                onClose={() => setShowTaskModal(false)}
            /> */}
            {/* Create Task Modal */}
            <PopUpModal
                visible={showTaskModal}
                onClose={() => setShowTaskModal(false)}
                confirmText="Create Task"
                title="Create New Task"
                size="medium"
            // onConfirm={handleSubmit}
            >
                <Formik
                    initialValues={{
                        title: '',
                        description: '',
                        dueDate: '',
                        priority: 'medium'
                    }}
                    validationSchema={taskSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log('Task submitted:', values);
                        setSubmitting(false);
                        setShowTaskModal(false);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="space-y-4">
                            <div className="form-group">
                                <label>
                                    Task title <span>*</span>
                                </label>
                                <Field
                                    type="text"
                                    name="title"
                                    placeholder="Upsell"
                                    className=""
                                />
                                <ErrorMessage name="title" component="div" className="text-red-500 text-sm" />
                            </div>
                            <div className="form-group">
                                <label>
                                    Description <span>*</span>
                                </label>
                                <Field
                                    as="textarea"
                                    name="description"
                                    // rows={3}
                                    placeholder="Enter task description"
                                />
                                <ErrorMessage name="description" component="div" className="text-red-500 text-sm" />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="form-group">
                                    <label>
                                        Priority <span>*</span>
                                    </label>
                                    <Select
                                        options={priorityOptions}
                                        defaultValue={priorityOptions[0]}
                                        name="priority"
                                        inputId="priority"
                                        isClearable={false}
                                        isSearchable={false}
                                        menuPlacement="auto"
                                    />
                                    <ErrorMessage name="priority" component="div" className="text-red-500 text-sm" />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Assignee <span>*</span>
                                    </label>
                                    <Select
                                        options={assigneeOptions}
                                        defaultValue={assigneeOptions[0]}
                                        isClearable={false}
                                        isSearchable={false}
                                        menuPlacement="auto"
                                        name="assignee"
                                        inputId="assignee"
                                    />
                                    <ErrorMessage name="assignee" component="div" className="text-red-500 text-sm" />
                                </div>
                            </div>

                        </Form>
                    )}
                </Formik>
            </PopUpModal>

            {/* Log Communication Modal */}
            <PopUpModal
                visible={showCommunicationModal}
                onClose={() => setShowCommunicationModal(false)}
                confirmText="Log Communication"
                title="Log Communication"
                size="medium"
            >
                <Formik
                    initialValues={{
                        name: '',
                        value: '',
                        stage: 'prospecting',
                        closeDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
                    }}
                    validationSchema={communicationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log('Opportunity added:', values);
                        setSubmitting(false);
                        setShowOpportunityModal(false);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="form-group">
                                    <label>
                                        Type <span>*</span>
                                    </label>
                                    <Select
                                        options={CommunicationType}
                                        defaultValue={CommunicationType[0]}
                                        name="Type"
                                        inputId="Type"
                                        isClearable={false}
                                        isSearchable={false}
                                        menuPlacement="auto"
                                    />
                                    <ErrorMessage name="Type" component="div" className="text-red-500 text-sm" />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Subject <span>*</span>
                                    </label>
                                    <Field
                                        type="text"
                                        name="subject"
                                        placeholder="communication subject"
                                    />
                                    <ErrorMessage name="subject" component="div" className="text-red-500 text-sm" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>
                                    Notes <span>*</span>
                                </label>
                                <Field
                                    as="textarea"
                                    name="description"
                                    rows={8}
                                    placeholder="Communication details and notes"
                                />
                                <ErrorMessage name="description" component="div" className="text-red-500 text-sm" />
                            </div>
                            <div className="form-group">
                                <label>
                                    Participants <span>*</span>
                                </label>
                                <Select
                                    options={participantsOptions}
                                    defaultValue={participantsOptions[0]}
                                    name="participants"
                                    inputId="participants"
                                    isClearable={false}
                                    isSearchable={false}
                                    menuPlacement="auto"
                                />
                                <ErrorMessage name="participants" component="div" className="text-red-500 text-sm" />
                            </div>
                        </Form>
                    )}
                </Formik>
            </PopUpModal>


            {/* Add Opportunity Modal */}
            <PopUpModal
                visible={showOpportunityModal}
                onClose={() => setShowOpportunityModal(false)}
                title="Add opportunities"
                size="medium"
                confirmText="Add Opportunities"

            >
                <Formik
                    initialValues={{
                        type: 'email',
                        summary: '',
                        details: '',
                        date: new Date().toISOString().split('T')[0]
                    }}
                    validationSchema={opportunitySchema}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log('Communication logged:', values);
                        setSubmitting(false);
                        setShowCommunicationModal(false);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="space-y-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="form-group">
                                    <label>
                                        Type <span>*</span>
                                    </label>
                                    <Select
                                        options={priorityOptions}
                                        defaultValue={priorityOptions[0]}
                                        name="Type"
                                        inputId="Type"
                                        isClearable={false}
                                        isSearchable={false}
                                        menuPlacement="auto"
                                    />
                                    <ErrorMessage name="Type" component="div" className="text-red-500 text-sm" />
                                </div>
                                <div className="form-group">
                                    <label>
                                        Stage <span>*</span>
                                    </label>
                                    <Select
                                        options={assigneeOptions}
                                        defaultValue={assigneeOptions[0]}
                                        isClearable={false}
                                        isSearchable={false}
                                        menuPlacement="auto"
                                        name="Stage"
                                        inputId="Stage"
                                    />
                                    <ErrorMessage name="Stage" component="div" className="text-red-500 text-sm" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>
                                    Title <span>*</span>
                                </label>
                                <Field
                                    as="input"
                                    name="title"
                                    placeholder="Opportunity Title"
                                />
                                <ErrorMessage name="Opportunity Title" component="div" className="text-red-500 text-sm" />
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="form-group">
                                    <label>
                                        Value ($) <span>*</span>
                                    </label>
                                    <Field
                                        as="input"
                                        name="value"
                                        placeholder="$0"
                                        type="number"
                                    />
                                    <ErrorMessage name="value" component="div" className="text-red-500 text-sm" />
                                </div> <div className="form-group">
                                    <label>
                                        Probability (%)<span>*</span>
                                    </label>
                                    <Field
                                        as="input"
                                        name="Probability (%)"
                                        placeholder="%"
                                        type="number"
                                    />
                                    <ErrorMessage name="Probability (%)" component="div" className="text-red-500 text-sm" />
                                </div>
                            </div>

                        </Form>
                    )}
                </Formik>
            </PopUpModal>

            {/* Impersonate Tenant Modal */}
            <PopUpModal
                visible={showImpersonateModal}
                onClose={() => setShowImpersonateModal(false)}
                title="Impersonate Tenant"
                confirmText="Okay"
                size="medium"
            >
                <Formik>
                    <Form className="space-y-4">
                        <div className="warning-label py-[19px] px-[13px] w-full flex gap-2 items-center rounded-lg bg-[#F5FFBD]">
                            <span className="min-w-[41px]">
                                {YellowWarningIcon}
                            </span>
                            <p className="m-0">Impersonation will be audited and limited to 30 minutes</p>
                        </div>
                        <div className="form-group">
                            <label>
                                Reasons for impersonation  <span>*</span>
                            </label>
                            <Field
                                as="textarea"
                                name="description"
                                rows={8}
                                placeholder="Please provide a detailed reason for impersonation"
                            />
                            <ErrorMessage name="description" component="div" className="text-red-500 text-sm" />
                        </div>
                    </Form>
                </Formik>
            </PopUpModal>
        </>
    );
}
